<template>
    <div class="row item-mobile-galler">
		<vue-gallery-slideshow :images="images" :index="index" @close="closePhotoFxn"
		style="background-color: rgba(0, 0, 0, 0.9); padding-top: 5%;"></vue-gallery-slideshow>
    </div>
</template>
 
<script>
import VueGallerySlideshow from 'vue-gallery-slideshow'
export default {
	name: "ViewPhoto",
	props: ['photo'],
	data() {
		return {
			photoHolder: require('../../../../public/img/web/anewitem-noimage.jpg'),
			images: [],
			index: null,
		}
	},
	methods: {
		extractPhoto(thePhoto) {
            if(thePhoto){
				this.images.push(thePhoto)
            }else{
				this.images.push(this.photoHolder)
			}
		},
		closePhotoFxn () {
			this.index = null
            this.$emit('closePhoto', true)
        }
	},
	components: {
		VueGallerySlideshow
	},
	watch: {
        photo() {
			this.images = []
            this.extractPhoto(this.photo)
        },
    },
	created() {
		this.index = 0
		this.extractPhoto(this.photo)
	}
}
</script> 